import React from "react";
import Center from "../../../../widget/common/ui/Center";
import { CompanyLogo } from "../widget/ForgotPasswordWidgets";
import Div from "../../../../widget/common/ui/Div";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { Col } from "react-bootstrap";
import { RecoverPasswordEmailField } from "./widget/RecoverPaswordTextfields";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { RecoverPasswordContextImport } from "../../../../provider/onboarding/forgot_password/recover_password/RecoverPasswordContextProvider";
import RecoverPasswordTypeSelection from "./widget/RecoverPasswordTypeSelection";

const RecoverPasswordContent = (props: { type: number }) => {
  const type: number = props.type;

  const { verificationType } = RecoverPasswordContextImport();

  return (
    <Div className="h-100 d-center">
      <Div>
        <Center>
          <CompanyLogo title={AppTranslation.text("recover_password")} />
        </Center>
        <Col xs={12} sm={8} className="mx-auto">
          <TextBlock
            center={true}
            fontSize="16_17"
            fontName="book"
            textColor="theme-label"
          >
            {verificationType === "0"
              ? AppTranslation.text("enter_email_and_send_link_reset_password")
              : AppTranslation.text(
                  "enter_email_or_mobile_and_send_link_reset_password"
                )}
          </TextBlock>
        </Col>
        <SpacingHeight value={type === 1 ? 35 : type === 2 ? 48 : 45} />
        <form>
          {verificationType === "0" ? (
            <RecoverPasswordEmailField />
          ) : (
            <RecoverPasswordTypeSelection />
          )}
        </form>
        <SpacingHeight value={type === 3 ? 100 : 20} />
      </Div>
    </Div>
  );
};

export default RecoverPasswordContent;
